document.querySelectorAll('.modal')
  .forEach((modal) => {
    $(modal)
      .on('shown.bs.modal', () => {
        // Set local storage key val to disable location popup
        localStorage.setItem('disable-popup-location', new Date().toISOString());
      })
      .on('hidden.bs.modal', () => {
        // Remove local storage key val to enable location popup
        // IF the modal is not the location modal
        if (modal.id !== 'location-modal') {
          localStorage.removeItem('disable-popup-location');
        }
      });
  });
